/**
 * The clearance contract for the fixed mobile tab bar.
 *
 * The bar is `position: fixed` at `z-index: 60`. Every full-screen surface —
 * the atelier modals, the catalogue's filter and sort sheets — sits below that,
 * so the bar was painted on top of them. On a 390×844 phone that put the filter
 * sheet's own commit button ("GÖSTƏR 260 MƏHSUL", 780→828) entirely underneath
 * the bar (775→844): the only visible way out of the sheet became ✕ or Escape,
 * both of which discard the selection.
 *
 * Raising the sheets above 60 would only move the collision. A tab bar is app
 * chrome, and app chrome does not belong on top of a modal — so while any
 * modal surface is open the bar is removed instead.
 *
 * Reference-counted, for the same reason `AtelierModal`'s scroll lock is:
 * React mounts effects twice in development, and modals can stack.
 */
const OPEN_CLASS = "adf-modal-open";

let openSurfaces = 0;

export function lockModalSurface() {
  openSurfaces += 1;
  if (openSurfaces === 1) {
    document.documentElement.classList.add(OPEN_CLASS);
  }
}

export function releaseModalSurface() {
  openSurfaces = Math.max(0, openSurfaces - 1);
  if (openSurfaces === 0) {
    document.documentElement.classList.remove(OPEN_CLASS);
  }
}

/** `useEffect(() => modalSurfaceEffect(open), [open])` — mount/unmount safe. */
export function modalSurfaceEffect(open) {
  if (!open) return undefined;
  lockModalSurface();
  return releaseModalSurface;
}
